export const cellMixins = {
  props: {
    cellData: {
      type: Object,
      required: true
    },
    docData: {
      type: Object,
      required: true
    }
  }
}
